import { Exercises, Workouts } from "app-interfaces";

import { ExerciseTypesEnum } from "../types/StaticTypes";

export default class CatalogClass {
  /* Properties */
  private _myExercises: Exercises.IExercise[] = [];
  private _Exercises: Exercises.IExercise[] = [];
  private _Workouts: Workouts.IWorkout[] = [];

  private _allExercisesMap: Map<string, Exercises.IExercise> = new Map();

  // Use these two to fetch incremental changes
  private exercisesLastUpdated: number = 0;
  private workoutsLastUpdated: number = 0;

  get MyExercises() {
    return this._myExercises.filter((ex) => !ex.is_deleted);
  }

  get Exercises() {
    return this._Exercises.filter((ex) => !ex.is_deleted);
  }

  get Workouts() {
    return this._Workouts;
  }

  // Setters
  setWorkouts(params: Workouts.IWorkout[], lastUpdate: number) {
    this.workoutsLastUpdated = lastUpdate;
    this._Workouts = params;
  }

  /* Methods */
  setExercises = (params: Exercises.IExercise[], updated: number) => {
    this.exercisesLastUpdated = updated;
    params.sort((a, b) => {
      const typeA = ExerciseTypesEnum[a.type];
      const typeB = ExerciseTypesEnum[b.type];
      return typeA > typeB ? 1 : typeA < typeB ? -1 : 0;
    });
    this._Exercises = params.filter((el) => !el.is_user_exercise);
    this._myExercises = params.filter((el) => el.is_user_exercise);
    this._allExercisesMap = new Map(params.map((ex) => [ex.id, ex]));

    return this;
  };

  findExercise(id?: string) {
    if (!id) return undefined;

    return this._allExercisesMap.get(id);
  }

  typesDisplay = (type: string): string => {
    switch (type) {
      case "COORDINATION":
        return "BALANCE & COORDINATION";
      case "WEIGHT":
        return "BODY WEIGHT";
      case "SUSPENSIONTRAINING":
        return "SUSPENSION TRAINING";
      case "PULSE_ZONE":
        return "PULSE ZONE";
      case "pulse_zone":
        return "pulse zone";
      case "KG_WEIGHTS":
        return "WEIGHTS";
      case "kg_weights":
        return "WEIGHTS";
      case "SLINGSUSPENSION":
        return "SLING SUSPENSION";
      case "FULLBODY":
        return "FULL BODY";
      default:
        return type;
    }
  };
  equipmentsDisplay = (equip: string): string => {
    switch (equip) {
      case "ARM_SLINGERS":
        return "ARM SLINGERS";
      case "BELT_SQUAT":
        return "BELT SQUAT";
      case "BODY_WEIGHT":
        return "BODY WEIGHT";
      case "BOSU_BALL":
        return "BOSU BALL";
      case "EZ_BARBELL":
        return "EZ BARBELL";
      case "JUMP_ROPE":
        return "JUMP ROPE";
      case "LEVERAGE_MACHINE":
        return "LEVERAGE MACHINE";
      case "MEDICINE_BALL":
        return "MEDICINE BALL";
      case "PARALLEL_BARS":
        return "PARALLEL BARS";
      case "POWER_SLED":
        return "POWER SLED";
      case "PUSH_UP_HANDLES":
        return "PUSH UP HANDLES";
      case "RESISTANCE_BAND":
        return "RESISTANCE BAND";
      case "ROW_MACHINE":
        return "ROW MACHINE";
      case "SKI_ERG":
        return "SKI ERG";
      case "SLED_MACHINE":
        return "SLED MACHINE";
      case "SMITH_MACHINE":
        return "SMITH MACHINE";
      case "STABILITY_BALL":
        return "STABILITY BALL";
      case "STAIR_STEPPER":
        return "STAIR STEPPER";
      case "STATIONARY_BIKE":
        return "STATIONARY BIKE";
      case "TRAP_BAR":
        return "TRAP BAR";
      case "VERSA_CLIMBER":
        return "VERSA CLIMBER";
      case "NO_EQUIPMENT":
        return "NO EQUIPMENT";
      default:
        return equip;
    }
  };
}
